document.addEventListener("DOMContentLoaded", () => {
  // Initialize each slider instance separately
  document
    .querySelectorAll(".ugc-video-slider")
    .forEach((slider) => initUGCSlider(slider));

  // Re-initialize when sections load in the theme editor
  document.addEventListener("shopify:section:load", (event) => {
    const slider = event.target.querySelector(".ugc-video-slider");
    if (slider) initUGCSlider(slider);
  });

  // Global click delegation for nav arrows
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".custom--flickity-arrow.flickity-nav");
    if (!btn) return;
    const ugcSlider = btn.closest(".ugc-video-slider");
    if (!ugcSlider) return;

    const group = ugcSlider.querySelector(
      '.videos-group.carousel[style*="display: block"]'
    );
    if (!group) return;
    const flkty = Flickity.data(group);
    if (!flkty) return;

    btn.classList.contains("flickity-prev") ? flkty.previous() : flkty.next();
    updateNavButtonVisibility(ugcSlider, flkty);
  });
});

function initUGCSlider(container) {
  initCarousels(container);
  setupVideos(container);
  setupTagFiltering(container);
  setupNavigation(container);

  // refresh nav-arrow visibility for the active tag
  const activeBtn = container.querySelector(".pill__ugc_slider.active");
  if (activeBtn) {
    const tag = activeBtn.dataset.tag;
    const group =
      tag === "all"
        ? container.querySelector(".videos-group.carousel")
        : container.querySelector(`.videos-group[data-tag="${tag}"]`);
    const flkty = group && Flickity.data(group);
    if (flkty) updateNavButtonVisibility(container, flkty);
  }
}

function initCarousels(container) {
  container.querySelectorAll(".videos-group.carousel").forEach((carousel) => {
    const existing = Flickity.data(carousel);
    if (existing) existing.destroy();
    new Flickity(carousel, {
      cellAlign: "center",
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: true,
    });
    carousel.classList.add("is-initialized");
  });
}

function setupVideos(container) {
  container.querySelectorAll(".video-container").forEach((vc) => {
    const video = vc.querySelector("video");
    const playBtn = vc.querySelector(".play-button");
    const pauseBtn = vc.querySelector(".pause-button");
    const muteBtn = vc.querySelector(".mute-button");
    const unmuteBtn = vc.querySelector(".unmute-button");
    if (!video || !playBtn || !pauseBtn || !muteBtn || !unmuteBtn) return;

    let userPaused = false;
    if (vc.observer) vc.observer.disconnect();
    ensureVideoIsReady(video);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !userPaused) {
            playVideoWhenReady(video, () => {
              playBtn.style.display = "none";
              pauseBtn.style.display = "block";
            });
          } else {
            video.pause();
            pauseBtn.style.display = "none";
            playBtn.style.display = "block";
          }
        });
      },
      { threshold: 0.2 }
    );
    vc.observer = observer;
    observer.observe(vc);

    // Replace buttons to strip old listeners
    const np = playBtn.cloneNode(true);
    const npa = pauseBtn.cloneNode(true);
    const nm = muteBtn.cloneNode(true);
    const nu = unmuteBtn.cloneNode(true);
    playBtn.replaceWith(np);
    pauseBtn.replaceWith(npa);
    muteBtn.replaceWith(nm);
    unmuteBtn.replaceWith(nu);

    const [up, pa, mu, um] = [
      vc.querySelector(".play-button"),
      vc.querySelector(".pause-button"),
      vc.querySelector(".mute-button"),
      vc.querySelector(".unmute-button"),
    ];

    up.addEventListener("click", () => {
      userPaused = false;
      playVideoWhenReady(video, () => {
        up.style.display = "none";
        pa.style.display = "block";
      });
    });

    pa.addEventListener("click", () => {
      userPaused = true;
      video.pause();
      pa.style.display = "none";
      up.style.display = "block";
    });

    video.addEventListener("click", () => {
      if (video.paused) {
        playVideoWhenReady(video, () => {
          up.style.display = "none";
          pa.style.display = "block";
        });
      } else {
        video.pause();
        pa.style.display = "none";
        up.style.display = "block";
      }
    });

    mu.addEventListener("click", (e) => {
      e.stopPropagation();
      video.muted = true;
      um.style.display = "block";
      mu.style.display = "none";
    });

    um.addEventListener("click", (e) => {
      e.stopPropagation();
      // mute all others
      container.querySelectorAll(".video-container").forEach((otherVC) => {
        const otherVideo = otherVC.querySelector("video");
        if (otherVideo && otherVideo !== video && !otherVideo.muted) {
          otherVideo.muted = true;
          otherVC.querySelector(".unmute-button").style.display = "block";
          otherVC.querySelector(".mute-button").style.display = "none";
        }
      });
      video.muted = false;
      um.style.display = "none";
      mu.style.display = "block";
    });

    video.addEventListener("ended", () => {
      userPaused = false;
      up.style.display = "block";
      pa.style.display = "none";
    });
  });
}

function ensureVideoIsReady(video) {
  if (!video.src && video.dataset.src) {
    video.classList.add("lazy-video");
  }
}

function playVideoWhenReady(video, callback) {
  if (
    video.classList.contains("lazy-video") &&
    !video.classList.contains("initialized")
  ) {
    video.addEventListener(
      "canplay",
      () => {
        video.play().catch(() => {
          console.log("Autoplay prevented by browser policy");
        });
        callback?.();
      },
      { once: true }
    );
    video.src = video.dataset.src;
    video.load();
    video.classList.add("initialized");
  } else {
    video.play().catch(() => {
      console.log("Autoplay prevented by browser policy");
    });
    callback?.();
  }
}

function setupTagFiltering(container) {
  // Strip old listeners
  container
    .querySelectorAll(".pill__ugc_slider")
    .forEach((b) => b.replaceWith(b.cloneNode(true)));

  // Attach click listeners
  container.querySelectorAll(".pill__ugc_slider").forEach((button) => {
    button.addEventListener("click", () => {
      activateTag(container, button.dataset.tag);
      updateHeaderVisibility(button.dataset.tag)
    });
  });

  // Initial state: first pill active
  const first = container.querySelector(".pill__ugc_slider")?.dataset.tag;
  if (first) activateTag(container, first);
}

function activateTag(container, tagName) {
  const buttons = container.querySelectorAll(".pill__ugc_slider");
  const groups = container.querySelectorAll(".videos-group");

  buttons.forEach((btn) =>
    btn.classList.toggle("active", btn.dataset.tag === tagName)
  );

  groups.forEach((group) => {
    if (tagName === "all" || group.dataset.tag === tagName) {
      group.style.display = "block";
      const flkty = Flickity.data(group);
      if (flkty) flkty.resize();
    } else {
      group.style.display = "none";
    }
  });
}

function setupNavigation(container) {
  container.querySelectorAll(".videos-group.carousel").forEach((carousel) => {
    const flkty = Flickity.data(carousel);
    if (!flkty) return;
    flkty.off("select", flkty._navBtnHandler);
    flkty._navBtnHandler = () => updateNavButtonVisibility(container, flkty);
    flkty.on("select", flkty._navBtnHandler);
    updateNavButtonVisibility(container, flkty);
  });
}

function updateNavButtonVisibility(container, flkty) {
  const prevBtn = container.querySelector(
    ".custom--flickity-arrow.flickity-prev"
  );
  const nextBtn = container.querySelector(
    ".custom--flickity-arrow.flickity-next"
  );
  if (!prevBtn || !nextBtn) return;

  const atStart = flkty.selectedIndex === 0;
  const atEnd = flkty.selectedIndex === flkty.slides.length - 1;
  prevBtn.style.display = atStart ? "none" : "";
  nextBtn.style.display = atEnd ? "none" : "";
}

function updateHeaderVisibility(tag) {
  const headerElements = document.querySelectorAll(".ugc-video-slider .headlines");

  headerElements?.forEach((header) => {
    if(header.dataset.tag === tag) {
      header.style.display = "block";
    } else {
      header.style.display = "none";
    }
  });
}